export const techs = [
  {
    name: 'React',
    iconName: 'react'
  },
  {
    name: 'Responsive',
    iconName: 'responsive'
  },
  {
    name: 'Javascript',
    iconName: 'javascript'
  },
  {
    name: 'CSS5',
    iconName: 'css3'
  },
  {
    name: 'HTML 5',
    iconName: 'html5'
  },
  {
    name: 'Mongo DB',
    iconName: 'mongodb'
  },
  {
    name: 'Bootstrap',
    iconName: 'bootstrap'
  },
  {
    name: 'firebase',
    iconName: 'firebase'
  },
  {
    name: 'Github',
    iconName: 'github'
  },
  {
    name: 'Jquery',
    iconName: 'jquery'
  },
  {
    name: 'PHP',
    iconName: 'php'
  },
  {
    name: 'sql',
    iconName: 'mysql'
  }
]